document.addEventListener('DOMContentLoaded', function () {
  var faqItems = document.querySelectorAll('.sprx-faq details');

  faqItems.forEach(function (item) {
    item.addEventListener('toggle', function () {
      if (!item.open) return;

      faqItems.forEach(function (other) {
        if (other !== item) other.open = false;
      });
    });
  });

  document.querySelectorAll('a[data-sprx-go]').forEach(function (anchor) {
    anchor.addEventListener(
      'click',
      function (e) {
        var url = anchor.getAttribute('data-sprx-go');
        if (!url || url === '#') return;
        e.preventDefault();
        e.stopPropagation();
        window.location.assign(url);
      },
      true
    );
  });
});
